export default __webpack_public_path__ + "static/media/desktopPurchaseSumary.46869006.png";